import { Box, Divider, List, ListItem, ListItemText, makeStyles, Typography } from '@material-ui/core';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import PersonOutlineRoundedIcon from '@material-ui/icons/PersonOutlineRounded';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import TopNav from '../common/TopNav';
import useSettingsData from './SettingsData';
import { NavLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	root: {
		marginLeft: theme.spacing(8),
		padding: theme.spacing(5, 4, 4),
		color: theme.palette.primary.main,
		display: 'flex',
		gap: theme.spacing(2.4),
		justifyContent: 'space-between',
		alignItems: 'stretch',
		"& > *": {
			flexBasis: '23%',
			flexGrow: 1,
			minWidth: '17rem'
		},
		"@media (max-width: 700px)": {
			marginLeft: 0,
			padding: theme.spacing(3, 0, 2),
			justifyContent: 'center',
			gap: theme.spacing(1.5),
			"& > *": {
				flexBasis: '90%',
				maxWidth: '90%',
				minWidth: 0,
				flexGrow: 0,
			},
		},
		"@media (max-width: 1230px)": {
			flexWrap: 'wrap',
		},
	},
	sectionCard: {
		padding: theme.spacing(2.1, 1.9, 1.7),
		borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
		background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(244, 249, 252, 0.98) 100%)',
		border: '1px solid rgba(37, 134, 188, 0.1)',
		boxShadow: '0 12px 24px rgba(16, 73, 105, 0.06), 0 1px 0 rgba(209, 227, 238, 0.66)',
	},
	sectionHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
		marginBottom: theme.spacing(0.55),
	},
	sectionIcon: {
		width: 34,
		height: 34,
		borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: theme.palette.primary.main,
		background: 'linear-gradient(180deg, rgba(239, 247, 252, 0.98) 0%, rgba(226, 240, 248, 0.98) 100%)',
		border: '1px solid rgba(37, 134, 188, 0.1)',
		boxShadow: '0 8px 16px rgba(16, 73, 105, 0.05)',
	},
	title: {
		fontSize: 14,
		textTransform: 'uppercase',
		fontWeight: 700,
		letterSpacing: 0.35,
		lineHeight: 1.2,
	},
	divider: {
		height: 2,
		width: 22,
		marginBottom: theme.spacing(0.9),
		backgroundColor: 'rgba(37, 134, 188, 0.22)',
	},
	list: {
		paddingTop: 0,
		paddingBottom: 0,
	},
	listItem: {
		padding: theme.spacing(1.05, 1.1),
		borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
		border: '1px solid transparent',
		transition: 'transform 180ms ease, background 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
		'&:hover': {
			background: 'linear-gradient(180deg, rgba(247, 252, 255, 0.98) 0%, rgba(235, 245, 250, 0.98) 100%)',
			borderColor: 'rgba(37, 134, 188, 0.12)',
			boxShadow: '0 10px 18px rgba(16, 73, 105, 0.06)',
			transform: 'translateY(-1px)',
		},
	},
	listText: {
		'& .MuiListItemText-primary': {
			fontSize: 15,
			fontWeight: 500,
			color: theme.palette.primary.main,
		},
	},
	itemArrow: {
		color: theme.palette.primary.main,
		opacity: 0.78,
		fontSize: '1.1rem',
	},
	navLink: {
		textDecoration: "none",
		color: "inherit"
	}
}));

const getSectionIcon = title => {
	switch (title) {
		case 'Usuario':
			return PersonOutlineRoundedIcon;
		case 'General':
			return SettingsOutlinedIcon;
		case 'Tarifas y Contratos':
			return DescriptionOutlinedIcon;
		case 'Analisis':
			return TimelineOutlinedIcon;
		default:
			return BusinessOutlinedIcon;
	}
};

export default function Settings() {
	const classes = useStyles();
	const settingsData = useSettingsData();
	return (
		<>
			<TopNav titulo='Configuración'></TopNav>

			<Box className={classes.root}>
				{settingsData.map((item, index) => {
					if(item.hasNotAccess) return null
					const SectionIcon = getSectionIcon(item.title);
					return (
						<Box key={index} className={classes.sectionCard}>
							<Box className={classes.sectionHeader}>
								<Box className={classes.sectionIcon}>
									<SectionIcon fontSize='small' />
								</Box>
								<Typography variant='h6' className={classes.title}>
									{item.title}
								</Typography>
							</Box>
							<Divider className={classes.divider} />
							<List dense className={classes.list}>
								{item.children
									.filter((child) => child.access) // Filtrar children por access
									.map((child, index) => (
										<NavLink
											key={index}
											className={classes.navLink}
											to={child.path}
										>
											<ListItem button className={classes.listItem}>
												<ListItemText primary={child.subtitle} className={classes.listText} />
												<ArrowForwardRoundedIcon className={classes.itemArrow} />
											</ListItem>
										</NavLink>
									))}
							</List>
						</Box>
					);
				})}
			</Box>
		</>
	);
}
